import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Row = styled(Box)({});

Row.defaultProps = {
  display: ['block', 'flex'],
  mx: -3,
};

export { Row };
